import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  addMaterialGroup,
  getMaterialGroups,
  updateMaterialGroup,
  deleteMaterialGroup,
} from "./materialGroupAPI";

const initialState = {
  loading: false,
  materialGroupList: [],
  pagination: {},
};

const actions = {
  CREATE_MATERIAL_GROUP: "materialGroup/CREATE_MATERIAL_GROUP",
  GET_MATERIAL_GROUPS: "materialGroup/GET_MATERIAL_GROUPS",
  UPDATE_MATERIAL_GROUP: "materialGroup/UPDATE_MATERIAL_GROUP",
  DELETE_MATERIAL_GROUP: "materialGroup/DELETE_MATERIAL_GROUP",
};

export const createMaterialGroupThunk = createAsyncThunk(
  actions.CREATE_MATERIAL_GROUP,
  async (payload) => {
    const response = await addMaterialGroup(payload);
    return response;
  }
);

export const getMaterialGroupsThunk = createAsyncThunk(
  actions.GET_MATERIAL_GROUPS,
  async (payload) => {
    const response = await getMaterialGroups(
      payload?.page,
      payload?.per_page,
      payload?.search
    );
    return response;
  }
);

export const updateMaterialGroupThunk = createAsyncThunk(
  actions.UPDATE_MATERIAL_GROUP,
  async ({ id, ...payload }) => {
    const response = await updateMaterialGroup(id, payload);
    return response;
  }
);

export const deleteMaterialGroupThunk = createAsyncThunk(
  actions.DELETE_MATERIAL_GROUP,
  async (id) => {
    const response = await deleteMaterialGroup(id);
    return response;
  }
);

export const materialGroupSlice = createSlice({
  name: "materialGroup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createMaterialGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMaterialGroupThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Material Group created successfully!");
        } else {
          message.error(msg || "Failed to create Material Group.");
        }
      })
      .addCase(createMaterialGroupThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to create Material Group.");
      });

    builder
      .addCase(getMaterialGroupsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMaterialGroupsThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, data } = action.payload;
        if (success) {
          state.materialGroupList = data?.data || [];
          state.pagination = data?.pagination || {};
        } else {
          message.error(msg || "Failed to fetch Material Groups.");
        }
      })
      .addCase(getMaterialGroupsThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to fetch Material Groups.");
      });

    builder
      .addCase(updateMaterialGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMaterialGroupThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Material Group updated successfully!");
        } else {
          message.error(msg || "Failed to update Material Group.");
        }
      })
      .addCase(updateMaterialGroupThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to update Material Group.");
      });

    builder
      .addCase(deleteMaterialGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteMaterialGroupThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Material Group deleted successfully!");
        } else {
          message.error(msg || "Failed to delete Material Group.");
        }
      })
      .addCase(deleteMaterialGroupThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to delete Material Group.");
      });
  },
});

export default materialGroupSlice.reducer;
